// Startup point for the client side application
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { renderRoutes } from "react-router-config";
import Routes from './Routes';

// REDUX
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import reducers from './reducers/index';


// material ui
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../helpers/theme';

// axios setup
// get('/users') -> get('/api/users')
import axios from 'axios';
const axiosInstance = axios.create({
    baseURL: '/api'
});
const axiosWithThunk = thunk.withExtraArgument(axiosInstance);

// the second argument is the inital value of the store.
// window.INITIAL_STATE is from server template.
const store = createStore(
    reducers, 
    window.INITIAL_STATE, 
    applyMiddleware(axiosWithThunk)
);



// boots up process
// tell client to re-assign all the event handler in root.
ReactDOM.hydrate(
    <Provider store={store}>
        <BrowserRouter>
            <ThemeProvider theme={theme}>   
                {renderRoutes(Routes)}
            </ThemeProvider>
        </BrowserRouter>
    </Provider>, 
    document.querySelector('#root')
);

 


// WEBPACK FOOTER //
// ./src/client/client.js